import type { WeaponType } from '@/types/season';

export const WEAPON_LABELS: Record<WeaponType, string> = {
  gun: 'Gun',
  bow: 'Bow',
  muzzleloader: 'ML',
  crossbow: 'XBow',
  youth: 'Youth',
  other: 'Other',
  any: 'Any',
};

/**
 * Returns true when a regulation `lastUpdated` date string (YYYY-MM-DD) is
 * more than 6 months before today.  Used to render a stale-data warning in
 * SeasonFormPage and testable without rendering the component.
 */
export function isRegulationDataStale(lastUpdated: string): boolean {
  const sixMonthsAgo = new Date();
  sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
  return new Date(lastUpdated) < sixMonthsAgo;
}
